import {useTranslation} from '@aboutyou/i18n';
import {styled} from '@linaria/react';
import React from 'react';
import {COLORS} from '../../../constants/colors';
import {Z_INDEXES} from '../../../constants/layers';

export const SkipToContentLink: React.FC = () => {
  const {t} = useTranslation();

  return (
    <StyledLink href="#page-content-wrapper">
      <span>{t('Skip to main content')}</span>
    </StyledLink>
  );
};

const StyledLink = styled.a`
  display: flex;
  justify-content: center;
  position: absolute;
  left: 0;
  top: 0;
  background: ${COLORS.Grey5};
  height: 30px;
  width: 100%;
  padding: 8px;
  transition: transform 0.3s;
  transform: translateY(-100%);
  z-index: ${Z_INDEXES.MODAL_DIALOG_WRAPPER};

  &:focus {
    transform: translateY(0%);
  }
`;
